"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AutoSuggestItem extends _react.PureComponent {
  _onClick = evt => {
    const {
      suggestion,
      onSuggestionSelect
    } = this.props;

    // only want to prevent default behavior if it's a google place suggestion
    if (!suggestion?.venue) {
      evt.preventDefault();
    }
    if (onSuggestionSelect) {
      onSuggestionSelect(suggestion);
    }
  };
  render() {
    const {
      active,
      className,
      suggestion,
      onSuggestionMouseDown,
      onSuggestionMouseOut
    } = this.props;
    const classes = (0, _classnames.default)('AutoSuggestInput-item', {
      'AutoSuggestInput-item-active': active
    }, className);
    return /*#__PURE__*/_react.default.createElement("li", {
      className: classes,
      onClick: this._onClick,
      onMouseDown: onSuggestionMouseDown,
      onMouseOut: onSuggestionMouseOut
    }, Boolean(suggestion?.componentToRender) ? suggestion?.componentToRender() : suggestion?.label);
  }
}
exports.default = AutoSuggestItem;